import request from "../../../helpers/request";

interface TRequestRptPtosConfig {
  idLoja: string;
  reportType: string;
}

export const getRptPtosConfig = async ({ idLoja, reportType }: TRequestRptPtosConfig) => {
  if (!idLoja) return null;
  const url = `${process.env.REACT_APP_API}/Relatorio/RptPtosConfig/${idLoja}?reportType=${reportType}`;
  const result = await request({ url, responseType: "blob" });
  return result;
};
